module.exports = __webpack_public_path__ + "img/appreciate.441d6af4.svg";